import {PositionModel} from "./PositionModel";
import * as ko from "knockout";
import {IKnockoutComponent, IObjectData} from "../../../index";
import {global, lm} from "../../../appContext";
import {ObjectTypeId} from "../../../constants";
import {getDataSourceTypesFromObject, getObjectDisplayName, getRawSyncFieldValue} from "../../../util/misc";
import {nsUserWizard} from "./nsUserWizard";
import {AbstractStep, IStepParams} from "./AbstractStep";
import {TSyncfield_Department, TSyncfield_User} from "../../../constants/Syncfields";
import {ImportFormatId} from "../../../constants/ImportFormats";
import {nsSyncFields} from "../../../req/nsSyncFields";
import {IComboboxOptions_syncfield} from "../../combobox/syncfield";
import TWizardSyncfield = nsUserWizard.TWizardSyncfield;
import TObjectData_basic = nsSyncFields.TObjectData_basic;
import positionHtml from './position.html?raw';

export let template = positionHtml;

interface IParams extends IStepParams<PositionModel> {
}

export class viewModel extends AbstractStep<PositionModel> {
    protected readonly organizationName: string;
    constructor(params: IParams) {
        super(params)
        this.organizationName = global.login.selectedOrganization()?.organizationame ?? '';
        this.init()
    }

    private init() {
        this.messageData(null)
        this.isReady(true)
    }

    private getCompanyDisplayValue (key: string): string {
        switch (key) {
            case 'Company':
                return this.organizationName;
            default:
                return '';
        }
    }

    private getRawSyncFieldValue(key: TSyncfield_Department, obj: TObjectData_basic | null = this.model.meta.department()): string {
        if (!obj) {
            return ''
        }
        return getRawSyncFieldValue(key, obj.syncfields) ?? ''
    }

    private getDepartmentDisplayName(department: IObjectData): string {
        const name = getObjectDisplayName(department) ?? ''
        const nr = getRawSyncFieldValue('OrgUnitnr', department.syncfields) ?? ''
        if (name.includes(nr)) {
            return name
        } else {
            return `${name} (${nr})`
        }
    }

    private getComponentOptions(syncfieldName: TWizardSyncfield): IKnockoutComponent | null {
        if (!this.model.meta.department())
            return null
        switch (syncfieldName) {
            case 'Manager': {
                const department = this.model.meta.department()!
                if (!getRawSyncFieldValue('Manager', department.syncfields)){
                    return null
                }
                return {
                    name: "component/variable/object-by-any",
                    params: {
                        argument: this.getRawSyncFieldValue('Manager'),
                        attribute: global.login.selectedOrganization()?.importformat?.id == ImportFormatId.Visma ? 'UserId' : 'EmployeeNumber',
                        linkable: false,
                        objectTypeId: ObjectTypeId.User,
                        datasources: getDataSourceTypesFromObject(department as IObjectData).join(',')
                    },
                }
            }
            default:
                return null
        }
    }

    private getComboboxParams_addOptionalSyncfield(): IComboboxOptions_syncfield {
        const ret: IComboboxOptions_syncfield = {
            comboboxOptions: {
                inputAttrs: {placeholder: lm.t('Add subject|s:((synchronization field|ac))')},
                prepareData: {
                    filter: sf => nsUserWizard.WizardOptionalPositionSyncfieldNames.includes(sf.name as TSyncfield_User),
                },
                option: {
                    constrain: sf => !this.model.optionalSyncfields().map(sf => sf.syncfieldid).includes(sf.syncfieldid),
                },
                selectionMode: 'pick',
                onSelect: o => {
                    if (o) {
                        this.model.onAddOptionalSyncfieldClick(o)
                    }
                },
            },
            objectTypeIds: ObjectTypeId.User,
            showIcon: true,
        }
        return ret
    }

}
